export default __webpack_public_path__ + "static/AllServices-0958ff49c495195309e99a8a06f36e86.png";